import { QueryKeys } from "@/constants/Query";
import axiosInstance from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export interface DosespotHealthCheckResponse {
  vendorResponsive: boolean;
}

export const useDosespotHealthCheck = () => {
  return useQuery<DosespotHealthCheckResponse>({
    queryFn: async () => {
      const response =
        await axiosInstance.get<DosespotHealthCheckResponse>(
          "/rx/support/health",
        );

      return response.data;
    },
    queryKey: QueryKeys.HealthChecks.ERX,
    refetchInterval: 1000 * 10,
    refetchIntervalInBackground: true,
  });
};
